import { url } from "../../constants/url";

export const fetchISECURIONUserList = async () => {
    try {
        const response = await fetch(`${url}/fetchclientuser`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch client messages');
        }
        const data = await response.json();
        // console.log(data)
        return { status: response.status, data };
    } catch (error) {
        console.error('Error fetching client messages:', error);
        return null;  
    }
};
